import { FormatConstants } from 'services/keyConstants';
export const getStatusTypes = (type) => {
  switch (type) {
    case FormatConstants.MAMOFPRODUCT.SAMPLING_PLAN:
      return {
        filteredData: {
          page: 1,
          totalPage: 1,
        },
      };
      break;

    case FormatConstants.MAMOFPRODUCT.INPROCESS_INSPECTION_REPORT:
      return {
        filteredData: {
          page: 1,
          totalPage: 1,
          status: "Open"
        },
        defaultOptionData: {
          statusOptions: [
            { label: "Open In-Process Inspection Report", value: "Open" },
            { label: "Close In-Process Inspection Report", value: "Close" },
          ]
        }
      };
      break;

    case FormatConstants.MAMOFPRODUCT.FINAL_INSPECTION_REPORT:
      return {
        filteredData: {
          page: 1,
          totalPage: 1,
          status: "Open"
        },
        defaultOptionData: {
          statusOptions: [
            { label: "Open In-Process Inspection Report", value: "Open" },
            { label: "Close In-Process Inspection Report", value: "Close" },
          ]
        }
      };
      break;

    // Default case if no matching type is found
    default:
      return {
        filteredData: {
          page: 1,
          totalPage: 1,
        },
        defaultOptionData: {
          statusOptions: []
        }
      };
  }
};
